import { FC } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

export interface FreeSubheadingProps {
    returnString?: boolean;
}

export const FreeSubheading: FC<FreeSubheadingProps> = ({ returnString }) => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderTextJSMLoggedOutFree",
        defaultMessage: "It’s free for up to 3 agents - no credit card needed."
    });

    return returnString ? (
        subHeaderText
    ) : (
        <p className="body-md" css={subHeaderCss}>
            {subHeaderText}
        </p>
    );
};
const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    fontFamily: wacToken("font.charlie.text"),
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    textAlign: "center",
    margin: "8px 0px 32px 0px"
});
